import React from "react";

// @material-ui/icons
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Radio from '@material-ui/core/Radio';
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";

import customCheckboxRadioSwitch from "../../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
	checkBoxLabelError: {
		background: "#ff0000"
	},
	infoText: {
		fontWeight: "300",
		margin: "10px 0 30px",
		textAlign: "center"
	},
	inputAdornmentIcon: {
		color: "#555"
	},
	inputAdornment: {
		position: "relative"
	},
	...customCheckboxRadioSwitch
};

class Step7 extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			companyState: "",
			department: "",
			firstName: "",
			firstNameState: "",
			lastName: "",
			lastNameState: "",
			streetNo: "",
			zip: "",
			city: "",
			cityState: "",
			country: "",
			countryState: "",
			phone: "",
			email: "",
			emailState: "",
			checked: "",
			checkedState: "",
			preferedContact: ""
		};
		this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
	}

	// function that returns true if value is email, false otherwise
	verifyEmail(value) {
		var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (emailRex.test(value)) {
			return true;
		}
		return false;
	}

	verifyLength(value, length) {
		if (value.length >= length) {
			return true;
		}
		return false;
	}

	change(event, stateName, type = null, stateNameEqualTo = -1){

		switch (type) {
			case "checkbox":
				if (event.target.checked) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
					this.setState({ [stateName + "State"]: "error" });
				}
				this.handleToggle(event.target.value);
				break;
			case "email":
				if (this.verifyEmail(event.target.value)) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
					this.setState({ [stateName + "State"]: "error" });
				}
				this.setState({ [stateName]: event.target.value });
				break;
			case "length":
				if (this.verifyLength(event.target.value, stateNameEqualTo)) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
				 this.setState({ [stateName + "State"]: "error" });
			 }
			 this.setState({ [stateName]: event.target.value });
			 break;
			default:
				this.setState({ [stateName]: event.target.value });
				break;
		}

	}

	handleChangeEnabled(event) {
		this.change(event, "selectedMaterial")
	}

	handleToggle(value) {
		const { checked } = this.state;
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		this.setState({
			checked: newChecked
		},() => {
			// noop
		});
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		if (
			this.state.emailState === "success" &&
			this.state.checkedState === "success" &&
			this.state.companyState === "success" &&
			this.state.firstNameState === "success" &&
			this.state.lastNameState === "success" &&
			this.state.cityState === "success" &&
			this.state.countryState === "success"

		){
			return true;
		} else {

			if (this.state.emailState !== "success"){
				this.setState({ emailState: "error" });
			}

			if (this.state.checkedState !== "success"){
				this.setState({ checkedState: "error" });
			}

			if (this.state.companyState !== "success"){
				this.setState({ companyState: "error" });
			}

			if (this.state.firstNameState !== "success"){
				this.setState({ firstNameState: "error" });
			}

			if (this.state.lastNameState !== "success"){
				this.setState({ lastNameState: "error" });
			}

			if (this.state.cityState !== "success"){
				this.setState({ cityState: "error" });
			}

			if (this.state.countryState !== "success"){
				this.setState({ countryState: "error" });
			}
		}
		return false;
	}

	isError(){
		return this.state.checkedState === "error"
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={12}>
					<h4 className={classes.infoText}>
						Please enter your contact data
					</h4>
				</GridItem>
			</GridContainer>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={4}>
				<CustomInput
					success={this.state.companyState === "success"}
					error={this.state.companyState === "error"}
					labelText="Company"
					id="company"
					formControlProps={{
						fullWidth: true
					}}
					inputProps={{
						onChange: event => this.change(event, "company", "length", 0)
					}}
				/>
				</GridItem>
				<GridItem xs={4}>
				<CustomInput
					labelText="Department"
					id="department"
					formControlProps={{
						fullWidth: true
					}}
					inputProps={{
						onChange: event => this.change(event, "department")
					}}
				/>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={4}>
				<CustomInput
					success={this.state.firstNameState === "success"}
					error={this.state.firstNameState === "error"}
					labelText="First name"
					id="firstname"
					formControlProps={{
						fullWidth: true
					}}
					inputProps={{
						onChange: event => this.change(event, "firstName", "length", 0)
					}}
				/>
				</GridItem>
				<GridItem xs={4}>
				<CustomInput
					success={this.state.lastNameState === "success"}
					error={this.state.lastNameState === "error"}
					labelText="Last name"
					id="lastname"
					formControlProps={{
						fullWidth: true
					}}
					inputProps={{
						onChange: event => this.change(event, "lastName", "length", 0)
					}}
				/>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={8}>
					<CustomInput
						labelText="Street No"
						id="streetno"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "streetNo")
						}}
					/>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={1}>
					<CustomInput
						labelText="Zip code"
						id="zip"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "zip")
						}}
					/>
				</GridItem>
				<GridItem xs={4}>
					<CustomInput
						success={this.state.cityState === "success"}
						error={this.state.cityState === "error"}
						labelText="City"
						id="city"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "city", "length", 0)
						}}
					/>
				</GridItem>
				<GridItem xs={3}>
					<CustomInput
						success={this.state.countryState === "success"}
						error={this.state.countryState === "error"}
						labelText="Country"
						id="country"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "country", "length", 0)
						}}
					/>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={4}>
					<CustomInput
						labelText="Phone"
						id="phone"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "phone")
						}}
					/>
				</GridItem>
				<GridItem xs={4}>
					<CustomInput
						success={this.state.emailState === "success"}
						error={this.state.emailState === "error"}
						labelText= {
							<span>
							Email*
							</span>
						}
						id="email"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "email", "email")
						}}
					/>
				</GridItem>
				<GridItem xs={8}>
					<CustomInput
						labelText="To contact prefered by"
						id="preferedContact"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "preferedContact")
						}}
					/>
				</GridItem>
				<GridItem xs={8}>
					<small>All inputs with * are mandatory!</small>
				</GridItem>
				<GridItem xs={8}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Checkbox
								onClick={event => {
									this.change(event, "checked", "checkbox");
								}}
								value="privacy"
								icon={<Check className={classes.uncheckedIcon + " " + (this.isError() ? classes.checkBoxLabelError:"")} />}
								checkedIcon={<Check className={classes.checkedIcon} />}
								classes={{
									checked: classes.checked
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Hereby, I accept the privacy policy."
					/>
				</div>
				</GridItem>
				<GridItem xs={8}>
				<small>
					<a href="https://3d-micromac.com/laser-micromachining/privacy-statement/" target="_blank">Link to privacy policy</a>
				</small>
				</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(Step7);



// WEBPACK FOOTER //
// ./src/views/ConfiguratorEN/ConfiguratorSteps/Step7.jsx